export var escapeSpecialChars = function (srcString) {
    return encodeURIComponent(srcString).replace(/'/g, '%27');
};
export var translateWithParams = function (t, tKey, tObj) {
    for (var key in tObj) {
        tObj[key] = escapeSpecialChars(tObj[key]);
    }
    return decodeURIComponent(t(tKey, tObj));
};
//# sourceMappingURL=generalUtils.js.map